import axios from 'axios'
import moment from 'moment-timezone'
import { STOCKS_ENDPOINT } from 'cfgCommon/endpoints'

export async function checkStockMassiveUpload(stocks) {
  const timezoneUser = moment.tz.guess()
  const inconsistencies = await axios.post(
    `${STOCKS_ENDPOINT}/checkStockMassiveUpload?timezoneUser=${timezoneUser}`,
    { stocks: stocks },
    { timeout: 1800000 } // 30 minutos
  ).then(res => res.data)
  return inconsistencies
}
